import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { ReducerState } from "../../types";
import TrapTable from "../../components/Traps/index";
import DeviceSetup from "../../components/DeviceSetup";
import "./index.css";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Traps: React.FC<Props> = () => {
  return (
    <div className="px-6 h-full w-full">
      <div className="text-[40px] my-6">Traps</div>
      <TrapTable />
      <DeviceSetup />
    </div>
  );
};

export default connector(Traps);
